var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTechnologiesToolsBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 608,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 801,
    y: 488,
    width: 93,
    height: 93,
    rx: 5,
    fill: "#387",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1302,
    y: 108,
    width: 93,
    height: 93,
    rx: 5,
    fill: "#387",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 701.774,
    y: 341,
    width: 6.452,
    height: 40,
    rx: 3.226,
    fill: "#F9DB6D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 356.484,
    width: 6.452,
    height: 40,
    rx: 3.226,
    transform: "rotate(90 725 356.484)",
    fill: "#F9DB6D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjYwOCIgdmlld0JveD0iMCAwIDE0NDAgNjA4IiBmaWxsPSJub25lIj4KICAgIDxyZWN0IHg9IjgwMSIgeT0iNDg4IiB3aWR0aD0iOTMiIGhlaWdodD0iOTMiIHJ4PSI1IiBmaWxsPSIjMzM4ODc3IiBmaWxsLW9wYWNpdHk9IjAuMSIvPgogICAgPHJlY3QgeD0iMTMwMiIgeT0iMTA4IiB3aWR0aD0iOTMiIGhlaWdodD0iOTMiIHJ4PSI1IiBmaWxsPSIjMzM4ODc3IiBmaWxsLW9wYWNpdHk9IjAuMSIvPgogICAgPHJlY3QgeD0iNzAxLjc3NCIgeT0iMzQxIiB3aWR0aD0iNi40NTE2MSIgaGVpZ2h0PSI0MCIgcng9IjMuMjI1ODEiIGZpbGw9IiNGOURCNkQiLz4KICAgIDxyZWN0IHg9IjcyNSIgeT0iMzU2LjQ4NCIgd2lkdGg9IjYuNDUxNjEiIGhlaWdodD0iNDAiIHJ4PSIzLjIyNTgxIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA3MjUgMzU2LjQ4NCkiIGZpbGw9IiNGOURCNkQiLz4KPC9zdmc+";
export { SvgTechnologiesToolsBg as ReactComponent };